export default "__VITE_ASSET__CVBfiwRp__"